import { Box, Typography } from '@mui/material'
import React from 'react'
import { ScrollFadeInSlideUp, ScrollReveal, SectionTitle } from '../../../components'

const CareerWhy = () => {
    const careerWhy = [
      {
        name:"Meaningful work",
        text:"At Pangu Enterprise, you'll contribute to projects that build more than just structures\u2014they shape communities, create lasting legacies, and drive the future of our region. As a construction general contractor, we take pride in delivering high-quality projects that stand the test of time, from innovative commercial developments to essential infrastructure. Every nail driven, every foundation poured, and every blueprint brought to life reflects our commitment to excellence. Join us to make a tangible impact you can see in the skyline and feel in the neighborhoods we serve."
      },
      {
        name:'Growth Opportunities',
        text:"We believe in building careers as strong as our projects. Whether you're a skilled tradesperson, an aspiring project manager, or a seasoned estimator, Pangu Enterprise offers clear pathways for professional development. From hands-on training and mentorship to opportunities to lead complex builds, we invest in your skills and ambition. Our projects vary in scope and scale, giving you the chance to expand your expertise, take on new challenges, and advance within a company that values your potential."
      },
      {
        name:'Collaborative Culture',
        text:"Construction is a team effort, and at Pangu Enterprise, you'll join a crew that thrives on creativity, diversity, and mutual respect. We bring together talented individuals from all backgrounds\u2014carpenters, engineers, architects, and administrators—united by a shared passion for getting the job done right. Our collaborative environment fosters open communication, innovative problem-solving, and a sense of camaraderie that makes even the toughest days rewarding. Here, your voice matters, your ideas shape outcomes, and your hard work is celebrated."
      }
    ]
  return (
    <Box
      sx={{
        background:'linear-gradient(to right, #A6A6A6, #fefefe)',
        
      }}
    >
      <Box
        sx={{
          background: `
          linear-gradient(135deg, #e0e0e0 25%, transparent 25%) -10px 0,
          linear-gradient(225deg, #e0e0e0 25%, transparent 25%) -10px 0,
          linear-gradient(315deg, #e0e0e0 25%, transparent 25%),
          linear-gradient(45deg, #e0e0e0 25%, transparent 25%)
        `
        }}
      >
        <ScrollFadeInSlideUp 
          sx={{
            paddingY:'2rem'
          }}
        direction='right'>
          <SectionTitle 
            firstTitleWord='Why work'
            secondTitleWord='with us'
            sx={{
              // paddingY:'2rem'
            }}
          />
        </ScrollFadeInSlideUp>
        <Box
          sx={{
            marginLeft:'5rem',
            width:'70%',
            '@media screen and (max-width: 762px)':{
              marginLeft:'2rem'
            }
          }}
        >
          {careerWhy.map((item, index) => (
            <ScrollReveal threshold='0.5'>
            <Box
              sx={{
                padingY:'4rem',
              }}
            >
              <Typography
                variant='h1'
                sx={{
                  fontSize:'2rem',
                  fontFamily:'var(--title-font)'
                }}
              >
                {item.name.split(' ').map((word, wordIndex) => (
                  <Box
                    key={wordIndex}
                    sx={{
                      display: 'inline', // Ensure words are displayed inline
                      color:
                        (index % 2 === 0 && wordIndex === 0) || // Style the first word for even indices
                        (index % 2 !== 0 && wordIndex === 1)    // Style the second word for odd indices
                          ? 'var(--color-secondary)'
                          : '#000', // Default color
                      fontWeight:
                        (index % 2 === 0 && wordIndex === 0) || // Bold the first word for even indices
                        (index % 2 !== 0 && wordIndex === 1)    // Bold the second word for odd indices
                          ? '1000'
                          : 'normal', // Default font weight
                      marginRight: '0.5rem', // Add spacing between words
                    }}
                  >
                    {word}
                  </Box>
                ))}
              </Typography>
              <Typography
                sx={{
                  marginLeft:'2rem',
                  paddingY:'1rem',
                  fontFamily:'var(--text-font)',
                  fontSize:'1.2rem'
                }}
              >{item.text}</Typography>
            </Box>
              </ScrollReveal>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default CareerWhy